var slider_active = false;
var current_slide = 1;
import TinyGesture from 'tinygesture';

document.addEventListener("DOMContentLoaded", function() {

    const slides = document.querySelectorAll('.slide__container');
    

    // Options object is optional. These are the defaults.
    const options = {
      // Used to calculate the threshold to consider a movement a swipe. it is
      // passed type of 'x' or 'y'.
      threshold: (type, self) =>
        Math.max(
          25,
          Math.floor(
            0.15 *
              (type === 'x'
                ? window.innerWidth || document.body.clientWidth
                : window.innerHeight || document.body.clientHeight)
          )
        ),
      // Minimum velocity the gesture must be moving when the gesture ends to be
      // considered a swipe.
      velocityThreshold: 10,
      // Used to calculate the distance threshold to ignore the gestures velocity
      // and always consider it a swipe.
      disregardVelocityThreshold: (type, self) =>
        Math.floor(0.5 * (type === 'x' ? self.element.clientWidth : self.element.clientHeight)),
      // Point at which the pointer moved too much to consider it a tap or longpress
      // gesture.
      pressThreshold: 8,
      // If true, swiping in a diagonal direction will fire both a horizontal and a
      // vertical swipe.
      // If false, whichever direction the pointer moved more will be the only swipe
      // fired.
      diagonalSwipes: false,
      // The degree limit to consider a swipe when diagonalSwipes is true.
      diagonalLimit: Math.tan(((45 * 1.5) / 180) * Math.PI),
      // Listen to mouse events in addition to touch events. (For desktop support.)
      mouseSupport: true,
    };


    if(slides.length > 1) {
        const no_of_slides = slides.length;
        const first_slide = slides[0];
        const slide_counter = document.getElementById('current_slide_no');

        //console.log('got ' + no_of_slides + '  slides');

        const slide_right_btn = document.getElementById('slides-nav-right');

        if(slide_right_btn){
            slide_right_btn.onclick = function(event) {
                if(!slider_active && (current_slide < no_of_slides)){                    
                    slider_active = true;
                    event.preventDefault();
                    event.stopPropagation();
                    let newSlidePos = current_slide * -100;
                    current_slide = current_slide + 1;
                    first_slide.style.marginLeft = newSlidePos + '%';
                    slide_counter.innerHTML = current_slide;
                    setTimeout(() => slider_active = false, 450);
                }
            }
        }

        const slide_left_btn = document.getElementById('slides-nav-left');

        if(slide_left_btn){
            slide_left_btn.onclick = function(event) {
                if(!slider_active && (current_slide > 1)){                    
                    slider_active = true;
                    event.preventDefault();
                    event.stopPropagation();
                    current_slide = current_slide - 1;
                    let newSlidePos = (current_slide -1) * -100;

                    first_slide.style.marginLeft = newSlidePos + '%';
                    slide_counter.innerHTML = current_slide;
                    setTimeout(() => slider_active = false, 450);
                }
            }
        }

        const target = document.getElementById('slider');
        const gesture = new TinyGesture(target, options);

        gesture.on('swipeleft', (event) => {
            if(!slider_active && (current_slide < no_of_slides)){
                slider_active = true;
                let newSlidePos = current_slide * -100;
                current_slide = current_slide + 1;
                first_slide.style.marginLeft = newSlidePos + '%';
                slide_counter.innerHTML = current_slide;
                setTimeout(() => slider_active = false, 450);
            }
        });

        gesture.on('swiperight', (event) => {
            if(!slider_active && (current_slide > 1)){                    
                slider_active = true;
                current_slide = current_slide - 1;
                let newSlidePos = (current_slide -1) * -100;

                first_slide.style.marginLeft = newSlidePos + '%';
                slide_counter.innerHTML = current_slide;
                setTimeout(() => slider_active = false, 450);
            }
        });
    }
});